import React from "react";
import {Box, Text} from "grommet";
import {IconAlertCircle, IconChevronRight as IconArrowRight} from '@tabler/icons-react';
import MessageBanner from "./MessageBanner";
import Icon from "./Icon";

// Something the merchant should act on, one line and one button. The dashboard's to-do banners,
// shared so every page that lists work at its top lists it the same way. Stacked in a plain Box
// (no gap), the bottom margin spaces them 12px apart.
// color and icon default to a warning; an informational line (something to look at, nothing
// wrong) passes text-info and IconInfoCircle so it reads the same, minus the alarm.
const AlertBanner = ({message, ctaText, onClick, showArrow = true, color = 'status-warning', icon = IconAlertCircle}) => (
    <MessageBanner
        message={(
            <Text weight={600}>
                {message}
            </Text>
        )}
        color={color}
        icon={icon}
        ctaText={(
            <Box direction="row" align="center" gap="xsmall">
                <Text>{ctaText}</Text>
                {showArrow && (<Icon SelectedIcon={IconArrowRight} size="xsmall" />)}
            </Box>
        )}
        ctaProps={{margin: {horizontal: 'medium'}}}
        onClick={onClick}
        containerProps={{margin: {bottom: 'small'}}}
        fill="horizontal"
    />
);

export default AlertBanner;
